import './raiseDownloadRequest.css';

import AssetSearchOption from '../../../lib/AssetSearchOption/AssetSearchOption';
import SelectWidget from '../../../lib/SelectWidget/SelectWidget';
import {
  fetchLienDeregistrationDataAction,
  getDocumentRedirectionInfoAction,
  getMyAccountDetailsAction,
  getServiceRequestDetailsAction,
  updateAssetStatus,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {getAPICall} from '../../../services/apiCallsHandler';
import Smartlook from '../../../utils/smartlook';
import {
  getCancellationType,
  getContractType,
  getLastDatesOfMonths,
  replaceTranslations,
  sendScreenViewNR,
  serviceRequestPostCall,
} from '../../../utils/util';
import ContractYearDropdown from '../../contractYearDropdown/contractYearDropdown';
import ViewAssetsButton from '../../EquipmentViewPopup/ViewAssetsButton/ViewAssetsButton';
import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';
import BillingPeriodSelect from '../BillingPeriodSelect/BillingPeriodSelect';
import LienRequestassetDetails from '../lienRequestassetDetails/lienRequestassetDetails';
import DocTypesForContractFiltering from './DocTypesForContractFiltering.json';

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  useToastProvider,
} from '@deere/fuel-react';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const shouldAddDocument = (document, isFromPastContract) => {
  if (isFromPastContract) {
    return document === 'LIEN_DE_REGISTRATION_LETTERS' || document === 'FINAEN';
  }
  return document !== 'LIEN_DE_REGISTRATION_LETTERS';
};

export const getAvailableDocumentTypes = ({
  country,
  contracts,
  pastContracts,
}) => {
  const documents = [];

  const addDocumentsForContracts = (contractList, isFromPastContract) => {
    const accountTypes = [
      ...new Set((contractList ?? []).map((contract) => contract.productLine)),
    ];
    for (const accountType of accountTypes) {
      const documentList =
        DocTypesForContractFiltering[country]?.[accountType] || [];
      for (const document of documentList) {
        if (
          !documents.includes(document) &&
          shouldAddDocument(document, isFromPastContract)
        ) {
          documents.push(document);
        }
      }
    }
  };

  addDocumentsForContracts(contracts, false);
  addDocumentsForContracts(pastContracts, true);
  return documents;
};

const RaiseDownloadRequest = (props) => {
  const {t} = useTranslation();
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(null);
  const [selectedContractNumber, setSelectedContractNumber] = React.useState();
  const [selectedBillingPeriod, setSelectedBillingPeriod] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [docType, setDocType] = React.useState('');
  const [showDocCreateSection, setShowDocCreateSection] = React.useState(false);
  const [assetContractOption, setAssetContractOption] = React.useState(null);
  const [filteredDropDownItems, setFilteredDropDownItems] = React.useState([]);
  const [selectedAssetDetails, setSelectedAssetDetails] = React.useState([]);
  const [lienDataLoaded, setLienDataLoaded] = React.useState(false);
  const [leaseInvoiceTimeout, setLeaseInvoiceTimeout] = React.useState(false);
  const [leaseInvoice5xx, setLeaseInvoice5xx] = React.useState(false);

  const assets =
    props?.lienDeregistrationData?.[selectedContractNumber]?.assets;

  const [selectedBalanceConfirmationDate, setSelectedBalanceConfirmationDate] =
    React.useState(null);
  const [balanceConfirmationDates, setBalanceConfirmationDates] =
    React.useState([]);
  const {enqueueToast} = useToastProvider();
  const contractClickHandler = (value) => {
    setSelectedContractNumber(value);
  };
  const billingPeriodClickHandler = (value) => {
    setSelectedBillingPeriod(value);
  };

  const dropDownItem = [
    {
      value: 'WELCOME_PACK',
    },
    {
      value: 'VAT_COPY',
      helperText: t('VAT_COPY_HELPER'),
    },
    {
      value: 'ANNUAL_INVOICES',
    },
    {
      value: 'ACCOUNT_STATEMENT',
    },
    {
      value: 'BALANCE_CONFIRMATION',
    },
    {
      value: 'REPAYMENT_PLAN',
      helperText: t('REPAYMENT_PLAN_HELPER'),
    },
    {
      value: 'COPY_OF_LOAN_LEASE_CONTRACT',
    },
    {
      value: 'LEASE_INVOICE',
    },
    {
      value: 'CERTIFICATES',
    },
    {
      value: 'LIEN_DE_REGISTRATION_LETTERS',
      helperText: t('LIEN_DE_REGISTRATION_LETTERS_HELPER'),
    },
    {
      value: 'RETENTION_ON_INTEREST_MODEL_30',
    },
    {
      value: 'FINAEN',
      helperText: t('CONTRACT_END_LETTER'),
    },
  ];
  const filterDropDownItems = () => {
    const dropDownDocuments = getAvailableDocumentTypes({
      country: props.country,
      contracts: props.contracts,
      pastContracts: props.pastContracts,
    });

    dropDownDocuments.sort((a, b) => t(a).localeCompare(t(b)));
    setFilteredDropDownItems(dropDownDocuments);
  };

  const clickHandler = (value) => {
    setSelectedItemIndex(value);
    setDocType(value);
    setShowDocCreateSection(true);
    setLeaseInvoiceTimeout(false);
    setLeaseInvoice5xx(false);
  };

  React.useEffect(() => {
    sendScreenViewNR('RaiseDownloadRequest');
    Smartlook.navigation('RaiseDownloadRequest');
  }, []);

  React.useEffect(() => {
    filterDropDownItems();
  }, [props.contracts, props.pastContracts]);

  React.useEffect(() => {
    const requestedDocType = props.documentRedirectionData?.selectedDocType;
    if (requestedDocType && filteredDropDownItems.includes(requestedDocType)) {
      clickHandler(requestedDocType);
      appStore.dispatch(getDocumentRedirectionInfoAction(null));
    }
  }, [filteredDropDownItems, props.documentRedirectionData]);

  React.useEffect(() => {
    if (docType == 'LIEN_DE_REGISTRATION_LETTERS') {
      setIsLoading(true);
      setShowDocCreateSection(false);
      appStore.dispatch(fetchLienDeregistrationDataAction(null));
      let isOrg = !!props.selectedOrg;
      getAPICall(
        `fetchLienValidity?isOrg=${isOrg}&customerId=${props.selectedOrg}`,
        {
          isCallBack: false,
          errorTag: 'FETCH_SERVICE_REQUEST_DOCUMENT',
          redirectToOops: false,
        },
        {
          stateName: 'lienDeregistrationData',
          actionName: fetchLienDeregistrationDataAction,
        }
      ).then((res) => {
        if (res.isError) {
          setIsLoading(false);
        } else {
          setShowDocCreateSection(true);
          setIsLoading(false);
          setLienDataLoaded(true);
        }
      });
    } else {
      setLienDataLoaded(false);
    }
  }, [docType, props.selectedOrg]);

  React.useEffect(() => {
    sendScreenViewNR('MyAccount');
    Smartlook.navigation('MyAccount');
    if (docType === 'BALANCE_CONFIRMATION') {
      setIsLoading(true);
      getAPICall(
        `myAccount`,
        {
          isCallBack: false,
          errorTag: 'GET_MYACCOUNT_DETAIL',
          redirectToOops: false,
        },
        {
          stateName: 'myAccountDetails',
          actionName: getMyAccountDetailsAction,
        }
      ).then((res) => {
        setIsLoading(false);
      });

      const dates = getLastDatesOfMonths('01/2022');
      setBalanceConfirmationDates(dates);
    }
  }, [docType]);

  const getHelperText = () => {
    for (let item of dropDownItem) {
      if (item.value === docType) {
        return item.helperText;
      }
    }
  };
  const submitHandler = () => {
    let data = {};
    if (props.selectedOrg) {
      data.party = props.selectedOrg;
    }
    if (selectedAssetDetails?.length > 0) {
      data.assets = selectedAssetDetails.join(', ');
    }

    if (docType === 'LIEN_DE_REGISTRATION_LETTERS') {
      let prodLine = props.pastContracts.find(
        (c) => c.contractNumber === selectedContractNumber
      ).productLine;

      data.eligibleForAssetDeregistration =
        props.lienDeregistrationData[
          selectedContractNumber
        ]?.eligibleForAssetDeregistration;
      data.contractType = getContractType(prodLine);

      data.cancellationType = getCancellationType(prodLine);
    }
    let docTypes = [];
    docTypes.push(docType);
    if (docType === 'LEASE_INVOICE' && props.country === 'es') {
      data['billingPeriod'] = selectedBillingPeriod;
    }
    if (docType === 'BALANCE_CONFIRMATION') {
      data['balanceConfirmationDate'] = selectedBalanceConfirmationDate;
    }
    if (docType === 'REPAYMENT_PLAN' && props.country === 'de') {
      data['isRescheduled'] =
        props.paymentSchedule[selectedContractNumber].isReSchedule === 'Y'
          ? true
          : false;
    }
    if (
      docType === 'RETENTION_ON_INTEREST_MODEL_30' &&
      props.country === 'pt'
    ) {
      data['accountNumber'] = props.contracts?.find(
        (contract) => contract.contractNumber === selectedContractNumber
      )?.accountNumber;
    }
    setLoader(true);
    setSubmitDisabled(true);
    serviceRequestPostCall(
      {
        requestType: 'Download Document',
        countryCode: props.country,
        userEmail: props.userDetails.email,
        contractNumber: selectedContractNumber,
        docsRequested: docTypes,
        translatedDocumentType: t([docType]),
        customerId: props['myAccountDetails']?.['personal']?.['customerId'],
        ...data,
      },
      enqueueToast,
      'CONTACT_CALLBACK_MODAL',
      (res) => {
        setLoader(false);
        setSubmitDisabled(false);
        if (docType == 'LIEN_DE_REGISTRATION_LETTERS') {
          const assetsLienLength = res?.assetsLienResponse?.length || 0;
          const assetsDMDLength = res?.assetsDMDFlow?.length || 0;
          if (assetsLienLength > 0) {
            for (const assetResponse of res.assetsLienResponse) {
              appStore.dispatch(
                updateAssetStatus({
                  contractNumber: selectedContractNumber,
                  serialNumber: assetResponse.serialNumber,
                  updatedFields: {
                    oid: assetResponse.oid,
                    lienDocumentStatus: 'Submitted',
                  },
                })
              );
            }
          }

          if (assetsDMDLength > 0) {
            for (const asset of res.assetsDMDFlow) {
              appStore.dispatch(
                updateAssetStatus({
                  contractNumber: selectedContractNumber,
                  serialNumber: asset.serialNumber,
                  updatedFields: {
                    guid: asset.guid,
                    lienDocumentStatus: 'Submitted',
                  },
                })
              );
            }
          }
          if (assetsLienLength > 0 && assetsDMDLength > 0) {
            enqueueToast({
              variant: 'success',
              title: t('DOCUMENT_REQUEST_SUBMITTED'),
              isCloseable: true,
            });
          } else if (assetsLienLength === 0) {
            enqueueToast({
              message: t('DOCUMENT_REQUEST_SUBMITTED'),
              variant: 'success',
            });
          } else if (assetsDMDLength === 0) {
            enqueueToast({
              variant: 'success',
              title: t('NO_DMD_ASSETS'),
              isCloseable: true,
            });
          }
        } else if (
          docType === 'COPY_OF_LOAN_LEASE_CONTRACT' ||
          (docType === 'LEASE_INVOICE' && props.country === 'es') ||
          (docType === 'WELCOME_PACK' && props.country === 'de') ||
          (docType === 'WELCOME_PACK' && props.country === 'gb') ||
          docType === 'FINAEN' ||
          docType === 'BALANCE_CONFIRMATION' ||
          docType === 'REPAYMENT_PLAN' ||
          docType === 'RETENTION_ON_INTEREST_MODEL_30'
        ) {
          if (res.url) {
            const urls = res.url.includes(',')
              ? res.url.split(',').map((url) => url.trim())
              : [res.url];
            for (const link of urls) {
              if (globalThis.ReactNativeWebView) {
                globalThis.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    docUrl: link,
                    docName: `JOHNDEERE_DOCUMENT_${Date.now()}.pdf`,
                  })
                );
              } else {
                globalThis.open(link, '_blank');
              }
            }
          }
        }
      },
      replaceTranslations(
        t('SERVICE_REQUEST_LIMIT'),
        50,
        t('DOWNLOAD_DOCUMENT')
      ),
      t('SERVICE_REQUEST_SUCCESS'),
      t('DOCUMENT_GENERATION_FAILURE'),
      (isAutomatedRequest) => {
        appStore.dispatch(getServiceRequestDetailsAction(null));
        if (!isAutomatedRequest) {
          props.onSuccess();
        }
      },
      false
    );
  };

  const handleDateSelection = (date) => {
    setSelectedBalanceConfirmationDate(date);
  };

  return (
    <>
      <div className="raiseDownloadRequestTop">
        <div className="raiseDownloadRequestHeader">
          <div className={'raiseDownloadRequestTitle'}>
            {t('RAISE_DOWNLOAD_REQUEST_TITLE')}
          </div>
          <div className={'raiseDownloadRequestSubTitle'}>
            {t('RAISE_DOWNLOAD_REQUEST_DESC')}
          </div>
        </div>
      </div>

      <div className="selectDropdownContainer">
        <SelectWidget
          id="requestTypeSelect"
          label={t('TYPES_OF_DOCUMENT')}
          placeholder={t('SELECT_DOCUMENT_TYPE')}
          changeHandler={clickHandler}
          data={filteredDropDownItems}
          required={true}
          multiple={false}
          hasSelectAll={false}
          disabled={false}
          value={selectedItemIndex ?? ''}
          defaultValue=""
        />
      </div>

      {props.contractDetailsLoader || isLoading ? (
        <SkeletonLoader componentName="ServiceRequestDashboard" />
      ) : showDocCreateSection ? (
        <>
          <div className="raiseDownloadRequestTop">
            <div className={'raiseDownloadRequestSubTitle'}>
              {getHelperText()}
            </div>
          </div>
          <Box pl={0} pb={4} pt={4}>
            {!leaseInvoiceTimeout &&
              !leaseInvoice5xx &&
              (props.country !== 'de' || docType !== 'BALANCE_CONFIRMATION' ? (
                <Card className="cardCustom">
                  <CardContent className="cardConentCustom ServiceRequestTypeField">
                    <div className="raiseDownloadAssetsWrapper">
                      <AssetSearchOption
                        searchTitle={t('SEARCH_OPTION_LABEL_DOCUMENT')}
                        setAssetContractOption={setAssetContractOption}
                        docType={docType}
                      />
                      <Box
                        pl={4}
                        pr={4}
                        pb={4}
                        className={'contractDetailSection'}
                      >
                        <div className="contractDetailHeaderSection">
                          <div className="contractContainer">
                            <div className="cardContentCustom">
                              <ContractYearDropdown
                                showYear={false}
                                onDropdownChange={(contractNo) =>
                                  contractClickHandler(contractNo)
                                }
                                docType={docType}
                                assetContractOption={assetContractOption}
                              />
                            </div>
                          </div>
                          <ViewAssetsButton
                            selectedContractNumber={selectedContractNumber}
                            docType={docType}
                          />
                        </div>
                      </Box>
                    </div>
                  </CardContent>
                </Card>
              ) : (
                <div className="BalanceConfirmationDatewrapper">
                  <div className="title">{t('BALANCE_CONFIRMATION')}</div>
                  <div className={'raiseDownloadRequestSubTitle'}>
                    {t('BALANCE_CONFIRMATION_SUBTITLE')}
                  </div>
                  <Card className="balanceConfirmationCard">
                    <CardContent className="cardConentCustom ServiceRequestTypeField">
                      <div className="selectBalanceConfirmationDateClass">
                        <SelectWidget
                          id="selectBalanceConfirmationDate"
                          changeHandler={handleDateSelection}
                          label={t('SELECT_DATE')}
                          data={balanceConfirmationDates}
                          multiple={false}
                          hasSelectAll={false}
                          disabled={false}
                          placeholder={`--${t('SELECT')}--`}
                          required={true}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </div>
              ))}

            {props.country === 'es' && docType === 'LEASE_INVOICE' ? (
              <BillingPeriodSelect
                selectedContractNumber={selectedContractNumber}
                countryCode={props.country}
                selectedOrg={props.selectedOrg}
                onTimeoutChange={setLeaseInvoiceTimeout}
                on5xxChange={setLeaseInvoice5xx}
                onDropdownChange={(billingPeriodItem) =>
                  billingPeriodClickHandler(billingPeriodItem)
                }
              />
            ) : null}

            {docType == 'LIEN_DE_REGISTRATION_LETTERS' && lienDataLoaded ? (
              <LienRequestassetDetails
                selectedContractNumber={selectedContractNumber}
                setSelectedAssetDetails={setSelectedAssetDetails}
                assets={
                  props.lienDeregistrationData?.[selectedContractNumber]?.assets
                }
              />
            ) : null}
            {!leaseInvoiceTimeout && !leaseInvoice5xx && (
              <div className="buttonControls">
                <Button
                  id="cancelButton"
                  data-testid="cancelButton"
                  onClick={() => {
                    setShowDocCreateSection(false);
                    setDocType(null);
                    setSelectedItemIndex(null);
                    setLeaseInvoiceTimeout(false);
                    setLeaseInvoice5xx(false);
                  }}
                  variant="secondary"
                >
                  {t('CANCEL')}
                </Button>

                <Button
                  id="phonePrimaryBtn"
                  data-testid="submitButton"
                  disabled={
                    (docType == 'LIEN_DE_REGISTRATION_LETTERS'
                      ? selectedAssetDetails?.length === 0
                      : false) ||
                    (docType == 'LIEN_DE_REGISTRATION_LETTERS' &&
                      assets?.every((asset) => asset?.lienDocumentStatus)) ||
                    (docType == 'BALANCE_CONFIRMATION' &&
                      !selectedBalanceConfirmationDate) ||
                    submitDisabled ||
                    (docType === 'LEASE_INVOICE' &&
                      props.country === 'es' &&
                      !selectedBillingPeriod)
                  }
                  onClick={() => submitHandler()}
                  variant="primary"
                  startIcon={
                    loader && (
                      <CircularProgress size="small" style={{color: '#000'}} />
                    )
                  }
                >
                  {(docType === 'LEASE_INVOICE' && props.country === 'es') ||
                  docType === 'FINAEN'
                    ? t('DOWNLOAD')
                    : t('SUBMIT')}
                </Button>
              </div>
            )}
          </Box>
        </>
      ) : null}
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    contracts: state.appStates.contractNumbers?.contracts,
    pastContracts: state.appStates.contractNumbers?.pastContracts,
    country: state.appStates.allContracts?.countryCode,
    userDetails: state.appStates.userDetailsInfo,
    selectedOrg: state.appStates.selectedOrg,
    contractDetailsLoader: state.appStates.contractDetailsLoader,
    lienDeregistrationData: state.appStates.lienDeregistrationData,
    myAccountDetails: state.appStates.myAccountDetails,
    documentRedirectionData: state.appStates.documentRedirectionData,
    paymentSchedule:
      state.appStates.paymentSchedule?.paymentSchedules?.installments ?? null,
  };
};
RaiseDownloadRequest.propTypes = {
  contracts: PropTypes.array,
  pastContracts: PropTypes.array,
  country: PropTypes.string,
  userDetails: PropTypes.object,
  selectedOrg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  contractDetailsLoader: PropTypes.bool,
  lienDeregistrationData: PropTypes.object,
  onSuccess: PropTypes.func,
  myAccountDetails: PropTypes.object,
  documentRedirectionData: PropTypes.object,
  paymentSchedule: PropTypes.object,
};
export default connect(mapStateToProps)(RaiseDownloadRequest);
